import { render, staticRenderFns } from "./ReSendQueueStep3.vue?vue&type=template&id=c81eea80&scoped=true&"
import script from "./ReSendQueueStep3.vue?vue&type=script&lang=js&"
export * from "./ReSendQueueStep3.vue?vue&type=script&lang=js&"
import style0 from "./ReSendQueueStep3.vue?vue&type=style&index=0&id=c81eea80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81eea80",
  null
  
)

export default component.exports